import React from 'react';
import SbEditable from 'storyblok-react';
import {
  BlokComponent,
  NewStoryblokMetaData,
  StoryblokAsset,
  StoryblokAuthor,
} from '../../types/blok.model';
import defaultTheme, { darkTheme } from '../../styles/themeVariables';
import RenderAfterPageTransition from '../../old/components/RenderAfterPageTransition';
import { ThemeProvider } from 'styled-components';
import { ThemeModeContextProvider } from '../../util/useThemeMode';

import ContactFormModule from '../modules/ContactFormModule';
import { RichTextDocument } from '../components/RichText/StoryblokRichText';
import Spacer from '../components/Spacer';
import PostHeaderModule from '../modules/PostHeaderModule';
import LongformTextModuleBlok from '../modules/LongformTextModule/LongformTextModule.blok';

interface LabsPostSchema extends NewStoryblokMetaData {
  title: string;
  author: StoryblokAuthor;
  hero_image: StoryblokAsset;
  hero_lg: StoryblokAsset;
  thumbnail_image: StoryblokAsset;
  content: RichTextDocument;
  hide_hero_image: boolean;
  hideAuthor?: boolean;
}

const LabsPost: BlokComponent<LabsPostSchema> = ({ blok, Dynamic }) => {
  return (
    <SbEditable content={blok}>
      <ThemeModeContextProvider themeMode={'light'}>
        <ThemeProvider theme={defaultTheme}>
          <PostHeaderModule
            key={blok._uid}
            title={blok.title}
            mobile={blok.hero_image?.filename}
            tablet={blok.hero_image?.filename}
            desktop={blok.hero_lg?.filename}
            alt={blok.hero_image?.alt}
            authors={[blok.author]}
            hideHeroImage={blok.hide_hero_image}
            hideAuthor={blok.hideAuthor}
          />

          <RenderAfterPageTransition>
            <Spacer className={`item-0 minimal`}>
              <LongformTextModuleBlok blok={blok} Dynamic={Dynamic} />
            </Spacer>
          </RenderAfterPageTransition>
        </ThemeProvider>
      </ThemeModeContextProvider>

      <ThemeModeContextProvider themeMode={'dark'}>
        <ThemeProvider theme={darkTheme(defaultTheme)}>
          <RenderAfterPageTransition>
            <ContactFormModule
              form_key={'/contact - general contact'}
              tagline={'READY TO GET STARTED?'}
              title={'Transform how your most important work is delivered'}
              subtitle={
                'Meet the team, discuss your ideas with our experts and receive a proposal for your project.'
              }
            />
          </RenderAfterPageTransition>
        </ThemeProvider>
      </ThemeModeContextProvider>
    </SbEditable>
  );
};

export default React.memo(LabsPost);
